import { BRAND } from "@/lib/brand";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
    const { t } = useI18n();
    return (
        <footer data-testid="site-footer" className="relative py-20 border-t border-[#C9A96E]/15">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row items-center md:items-end justify-between gap-10">
                    <div className="text-center md:text-left">
                        <div className="flex items-center gap-3 justify-center md:justify-start">
                            <img src={BRAND.logo} alt="LuxeNova" className="h-14 w-14 rounded-full object-cover ring-1 ring-[#C9A96E]/30" />
                            <div>
                                <div className="font-serif-display text-white text-2xl">LuxeNova</div>
                                <div className="mt-1 text-[10px] tracking-[0.35em] uppercase text-[#C9A96E]/80">
                                    {t("footer.tagline")}
                                </div>
                            </div>
                        </div>
                        <div className="mt-6 text-sm text-slate-400">{BRAND.city}</div>
                    </div>

                    <div className="text-center md:text-right">
                        <div className="text-slate-400 text-xs tracking-[0.24em] uppercase">{t("footer.discover")}</div>
                        <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 justify-center md:justify-end text-sm text-slate-300">
                            {[
                                { href: "#home", label: t("nav.home") },
                                { href: "#property", label: t("nav.property") },
                                { href: "#concierge", label: t("nav.concierge") },
                                { href: "#events", label: t("nav.events") },
                                { href: "/blog", label: t("nav.journal") },
                                { href: "#contact", label: t("nav.contact") },
                            ].map((l) => (
                                <a key={l.href} href={l.href} className="hover:text-[#C9A96E] transition-colors">
                                    {l.label}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
                    <div>© {new Date().getFullYear()} LuxeNova. {t("footer.rights")}</div>
                    <div className="tracking-[0.24em] uppercase">{t("footer.crafted")}</div>
                </div>
            </div>
        </footer>
    );
}
